import React from "react";
import { navigate } from "@reach/router";
import { Grid, Box, Typography, Button } from "@material-ui/core";
import { MemoryRounded, PersonRounded } from "@material-ui/icons";

import lodash from "lodash";

export default function FactoryCard(props) {
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  const { factory, factoryID } = props;

  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */

  return (
    <Grid item xs={12} md={6} lg={4}>
      <Box p={3} bgcolor="grey.600" borderRadius="borderRadius">
        <Grid container>
          <Grid item xs={12}>
            <Grid container justify="space-between" alignItems="center">
              <Typography className="break-all">
                {factory.factory ? factory.factory.name : ""}
              </Typography>
            </Grid>

            <Box ml={1} mb={3} color="grey.500" className="break-all">
              <Typography>{factory.description}</Typography>
            </Box>
          </Grid>

          <Grid
            item
            xs={3}
            container
            alignItems="center"
            className="border-t p-1 border-gray-500"
          >
            <Box color="grey.500">
              <MemoryRounded />
            </Box>
            <Typography>{lodash.size(factory.devices)}</Typography>
          </Grid>

          <Grid
            item
            xs={3}
            alignItems="center"
            container
            className="border-t border-r p-1 border-gray-500"
          >
            <Box color="grey.500">
              <PersonRounded />
            </Box>
            <Typography>0</Typography>
          </Grid>

          <Grid
            item
            xs={6}
            alignItems="center"
            justify="center"
            container
            className="border-t pt-2 border-gray-500"
          >
            <div className="flex w-full justify-end">
              <Button
                variant={"contained"}
                size="large"
                onClick={() => navigate(`/${factory.provider}/${factoryID}`)}
              >
                DETAIL
              </Button>
            </div>
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
}

/**
|--------------------------------------------------
| Default Props
|--------------------------------------------------
*/
FactoryCard.defaultProps = {
  factory: {},
};
